import React from 'react';
import { Menu, MenuItem } from '../../Menu';
import { categoryDeletable } from '../../../domain/expenseForms';
import s from './categories.module.css';

// One category. The Transactions count is the interesting column: it is what
// tells a teacher whether deleting is free or whether it will strip the label
// off eleven entries, and it is why the delete confirm names the count.

const CHIP = {
  expense: [s.chipExpense, 'Expense'],
  revenue: [s.chipRevenue, 'Revenue'],
};

export default function CategoryRow({ category, menuOpen, onToggleMenu, onEdit, onDelete }) {
  const [chipClass, chipLabel] = CHIP[category.type] || CHIP.expense;

  return (
    <tr>
      <td>
        <div>{category.label}</div>
        {/* The one category the system itself files into. Renaming it is fine;
            removing it would leave family payments with nowhere to land. */}
        {category.isSystem ? <span className={s.badge}>Default</span> : null}
      </td>
      <td><span className={chipClass}>{chipLabel}</span></td>
      <td className={s.right}>{category.count}</td>
      <td className={s.actionsCell}>
        <Menu
          open={menuOpen}
          onClose={() => onToggleMenu(null)}
          trigger={(
            <button
              className={s.kebab}
              aria-label={`Actions for ${category.label}`}
              onClick={() => onToggleMenu(menuOpen ? null : category.id)}
            >
              ⋮
            </button>
          )}
        >
          <MenuItem icon="pencil" onClick={() => onEdit(category)}>Edit Category</MenuItem>
          <MenuItem
            icon="trash"
            disabled={!categoryDeletable(category)}
            title={category.isSystem ? 'Family payments file into this category' : undefined}
            onClick={() => onDelete(category)}
          >
            Delete Category
          </MenuItem>
        </Menu>
      </td>
    </tr>
  );
}
